module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-my-orders"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.my_orders.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-my-orders__main"
  }, [_c('section', {
    staticClass: "c-page-header"
  }, [_c('div', {
    staticClass: "c-page-header__left"
  }, [_c('h1', {
    staticClass: "c-page-header__left__title"
  }, [_vm._v(_vm._s(_vm.$t('web.my_orders.page_header')))])])]), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--orders"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.my_orders.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--orders__body"
  }, [(_vm.orders.orders.length > 0) ? _c('order-list', {
    attrs: {
      "orders": _vm.orders,
      "fetchOrderCallback": _vm.fetchOrders
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e510a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MyOrders.vue
// module id = 517
// module chunks = 1